import Button from '@/src/app/components/Button/Button';

export default Button;
